export default "__VITE_ASSET__Cqe_wYZT__"